import type { ShapeData } from '@/lib/shapes/types/shape-data'
import { resolvePlacedPhotoIdentity } from '@/lib/photos/fill-shape-with-photo'

/**
 * A placed photo is a shape with a `photoFill` (standalone drop or shape fill — see
 * fill-shape-with-photo.ts). Normalize imageId/imageDisplayName onto the shape so PhotosPanel
 * doesn't need to know the underlying representation. Surfaced when Photo is directly applicable
 * (exactly one photo selected, nothing else) or read-only via `readOnlyPhoto` — the one
 * unambiguous photo behind a mixed selection or a single group holding exactly one photo.
 * `interactionLocked` stays true for the read-only cases, so they're display-only. Every
 * other case (no photo, multiple photos, locked, no selection) falls through to PhotosPanel's
 * own "blank fields" empty state, disabled via `interactionLocked`.
 */
export function resolveSelectedPhotoShape(
  activeObject: ShapeData | null,
  photoApplicable: boolean,
  readOnlyPhoto: ShapeData | null
) {
  const source = photoApplicable && activeObject ? activeObject : readOnlyPhoto

  if (!source) return undefined

  const identity = resolvePlacedPhotoIdentity(source)

  if (!identity) return undefined

  return { ...source, imageId: identity.imageId, imageDisplayName: identity.displayName }
}
